import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Card } from "antd";
import CasesTableContainer from "../cases-table-container";

const JudgeCases = ({ name, type, style }) => {
  const query = {
    [`judges.${type}`]: name,
    sort: "-filing_date"
  };
  const linkPTABCaseList = (
    <Link
      to={{
        pathname: "/ptab/caselist",
        query
      }}
    >
      {"See in PTAB Case List"}
    </Link>
  );
  return (
    <Card title="PTAB Cases" extra={linkPTABCaseList} style={style}>
      <CasesTableContainer
        queries={query}
        shouldSelectColumns={false}
        shouldExport={false}
        size="small"
      />
    </Card>
  );
}

JudgeCases.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["author", "panel"]).isRequired
};

export default JudgeCases;
